import { StyleSheet } from 'react-native'
import STYLES from '../../constants/styles'

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject
        , justifyContent: 'space-between'
        , alignItems: 'center'
    },
    card: {
        backfaceVisibility: 'hidden'
        , backgroundColor: STYLES.BACKGROUND_COLOR
        , position: 'absolute'
        , top: 0
        , justifyContent: 'space-between'
        , alignItems: 'center'
        , padding: 20
    },
    header: {
        flexDirection: 'row'
        , justifyContent: 'space-between'
        , alignSelf: 'stretch'
    },
    headerText: {
        fontSize: 28
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    subHeaderText: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.PRIMARY_TEXT_COLOR
    },
    headerPeriodText: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.PRIMARY_TEXT_COLOR
    },
    headerMoney: {
        fontSize: 30
        , fontWeight: 'bold'
        , color: STYLES.LIGHT_GREEN
    },
    accHeaderContent: {
        flexDirection: 'row'
        , paddingVertical: 20
    },
    accHeaderLine: {
        borderTopWidth: 1
        , borderColor: 'rgba(102, 102, 102, 0.1)'
    },
    accHeaderContentActive: {
        // backgroundColor: 'grey'
    },
    accHeaderMain: {
        flex: 5
        , flexDirection: 'row'
        , justifyContent: 'flex-start'
        , alignItems: 'flex-start'
    },
    accHeaderType: {
        marginRight: 10
    },
    accHeaderMainView: {
        flexDirection: 'column'
    },
    accHeaderMainText1: {
        fontSize: 16
        , fontWeight: 'bold'
        , color: STYLES.TRANSACTIONS_DATE
    },
    accHeaderMainText2: {
        fontSize: 14
        , color: STYLES.TRANSACTIONS_DATA
    },
    accHeaderValue: {
        flex: 2
        , justifyContent: 'flex-start'
        , alignItems: 'flex-end'
    },
    accHeaderValueText: {
        fontSize: 16
        , fontWeight: 'bold'
        , color: STYLES.TRANSACTIONS_DATE
    },
    accHeaderValueText2: {
        fontSize: 14
        , color: STYLES.TRANSACTIONS_DATE
    },
    symbols: {
        borderRadius: 18
        , width: 36
        , height: 36
        , justifyContent: 'center'
        , alignItems: 'center'
    },
    symbolNew: {
        backgroundColor: STYLES.TRANS_NEW_COLOR
    },
    symbolRecurring: {
        backgroundColor: STYLES.TRANS_RECURRING_COLOR
    },
    symbolText: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: '#fff'
    }
})



// WEBPACK FOOTER //
// ./src/components/listings/styles.js